<template>
  <div class="alert-block">
    <slot/>
  </div>
</template>

<script>
export default {
  name: "AlertBlock"
}
</script>

<style lang="scss">
.alert-block {
  @apply relative bg-block border border-border p-6 leading-7 text-text text-2sm rounded;

  &:before{
    content:'';
    @apply absolute bg-block border border-border;
    top: -6px;
    left: 24%;
    width: 12px;
    height: 12px;
    transform: rotate(-45deg);
    clip-path: polygon(0 0, 100% 0, 100% 100%);
  }
}

</style>